// components/AssinaturaLoginSenha.tsx
import {
  Alert,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDocumentoAssinarLoginMutation } from "./documentoAssinarApiSlice";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

type Props = {
  documento: string;
};

const AssinaturaLoginSenha = ({ documento }: Props) => {
  const [login, setLogin] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [alertVisible, setAlertVisible] = useState(false);
  const [msgAlert, setMsgAlert] = useState("");

  const [assinarLogin, { isLoading, isSuccess, isError, error }] =
    useDocumentoAssinarLoginMutation();

  const navigate = useNavigate();

  const handleSign = async (e: React.FormEvent) => {
    e.preventDefault();


    try {
      const params = {
        login: login,
        senha: senha,
        idDocumento: documento,
      };

      const result = await assinarLogin(params).unwrap();
      setAlertVisible(false);

      enqueueSnackbar("Documento Assinado com sucesso!", {
        variant: "success",
      });
      navigate(-1); // Usando useNavigate para navegação
    } catch (err: any) {
      
      setAlertVisible(true);
      const msg = err?.data?.message || "Erro ao assinar documento, verifique seu usuário e sua senha.";
      setMsgAlert(msg);
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <form onSubmit={handleSign} method="POST">
        <Box>
          {alertVisible && (
            <Alert
              variant="filled"
              severity="error"
              aria-hidden="true"
              sx={{ marginBottom: "16px" }}
            >
              {msgAlert}
            </Alert>
          )}
        </Box>

        <Typography variant="h6">Assinar com Login e Senha</Typography>
        <Box mt={2}>
          <TextField
            label="Login"
            required
            fullWidth
            margin="normal"
            value={login}
            size="small"
            onChange={(e) => setLogin(e.target.value)}
          />
          <TextField
            required
            label="Senha"
            type="password"
            fullWidth
            margin="normal"
            size="small"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
          <Button variant="contained" color="primary" type="submit">
            Assinar
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default AssinaturaLoginSenha;
